import { appConfig } from "@/commons";

export type Profile = {
  id: string;
  pseudo: string;
  full_name: string;
  email: string;
  locality?: string | null;
  birth_year?: number | null;
  gender?: string | null;
  region?: string | null;
};

export type UpdateProfilePayload = {
  pseudo?: string;
  full_name?: string;
  email?: string;
  locality?: string;
  birth_year?: number;
  gender?: string;
  region?: string;
};

const getErrorMessage = async (
  response: Response,
  fallback: string,
): Promise<string> => {
  const data = await response.json().catch(() => null);

  if (Array.isArray(data?.message)) {
    return data.message.join(", ");
  }

  return data?.message ?? fallback;
};

export const getProfile = async (): Promise<Profile> => {
  const response = await fetch(`${appConfig.api.baseUrl}/users/me`, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(
      await getErrorMessage(response, "Impossible de charger votre profil"),
    );
  }

  return response.json();
};

export const updateProfile = async (
  payload: UpdateProfilePayload,
): Promise<Profile> => {
  const response = await fetch(`${appConfig.api.baseUrl}/users/me`, {
    method: "PATCH",
    credentials: "include",

    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },

    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(
      await getErrorMessage(response, "Impossible de modifier votre profil"),
    );
  }

  return response.json();
};
